import ColorBlocks from './ColorBlocks';

export default ColorBlocks;
